import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

export function usePlans() {
  return useQuery({
    queryKey: ["plans"],
    queryFn: () => api.listPlans().then((r) => r.plans),
  });
}
